<template>
  <v-dialog v-model="show" persistent max-width="400">
    <v-card :class="classContents">
      <v-card-title>
        <h3>{{ $t('system.jco.add.title') }}</h3>
      </v-card-title>
      <v-form ref="form" v-model="valid">
        <v-row class="mx-3 mt-3">
          <v-col cols="12" class="pr-5">
            <v-card flat class="dialog-form" :class="classContents">
              <div class="d-flex flex-column">
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ $t('system.host') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-text-field v-model="item.host" :rules="[rules.required]" class="w-auto" outlined dense></v-text-field>
                  </div>
                </div>
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ $t('system.username') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-text-field v-model="item.username" :rules="[rules.required]" class="w-auto" outlined dense></v-text-field>
                  </div>
                </div>
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ $t('system.password') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-text-field v-model="item.password" :rules="[rules.required]" class="w-auto" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword" outlined dense></v-text-field>
                  </div>
                </div>
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ $t('common.language') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-select v-model="item.language" :items="languages" :rules="[rules.required]" item-text="text" item-value="value" class="item-select w-auto" :placeholder="this.$t('common.noSelect')" outlined dense></v-select>
                  </div>
                </div>
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ $t('system.clientNumber') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-text-field v-model="item.clientNumber" :rules="[rules.required]" class="w-auto" outlined dense></v-text-field>
                  </div>
                </div>
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ $t('system.systemNumber') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-text-field v-model="item.systemNumber" :rules="[rules.required]" class="w-auto" outlined dense></v-text-field>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="register('jco')" :disabled="disabledRegister">{{ $t('common.register') }}</v-btn>
        <v-btn small color="primary" @click="cancel">{{ $t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import addable from './mixins/addable';

const defaultItem = {
  host: '',
  username: '',
  password: '',
  language: '',
  clientNumber: '',
  systemNumber: '',
};

export default {
  mixins: [addable],
  data() {
    return {
      showPassword: false,
      languages: [],
    };
  },
  computed: {
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  methods: {
    onShow() {
      this.languages = Object.keys(this.$i18n.messages).map(lang => ({
        value: lang,
        text: this.$i18n.messages[lang]['common.localLanguageName'],
      }));
    },
  },
  created() {
    this.item = defaultItem;
  },
};
</script>

<style scoped>
.empty {
  height: 50px;
}
</style>
<style>
.item-select .v-input__slot {
  height: 24px;
}
.v-input__append-inner {
  margin-top: 2px !important;
}
.v-input__prepend-inner {
  margin-top: 2px !important;
}
</style>
